<template>
  <Card class="flex-none w-[400px]">
    <template #header>
      <div class="flex flex-row px-5 py-3 justify-center rounded-t-xl bg-primary-200 dark:bg-primary-700">
        <h1 class="font-bold text-xl">Primary Project Entities</h1>
      </div>
    </template>
    <template #content>
      <div v-if="project" class="flex flex-col gap-8 px-10 my-auto h-full justify-center" pt:body:class="h-full" pt:content:class="h-full">
        <EntityInformation
          v-model="project.projectInfo.sendProcessorCompletionEmail"
          label="Processor"
          :project-id="project.projectInfo.projectId"
          :entity="project.projectInfo.processor"
          :type="ProjectRole.PROCESSOR"
          :draw-number="project.projectDrawInfo.drawNumber"
          @entity-selected="entitySelected"
        ></EntityInformation>
        <EntityInformation
          v-model="project.projectInfo.sendLenderCompletionEmail"
          label="Primary Lender"
          :project-id="project.projectInfo.projectId"
          :entity="project.projectInfo.lender"
          :type="ProjectRole.PRIMARY_LENDER"
          :draw-number="project.projectDrawInfo.drawNumber"
          @entity-selected="entitySelected"
        ></EntityInformation>
        <EntityInformation
          v-model="project.projectInfo.sendBorrowerCompletionEmail"
          label="Primary Borrower"
          :project-id="project.projectInfo.projectId"
          :entity="project.projectInfo.borrower"
          :type="ProjectRole.PRIMARY_BORROWER"
          :draw-number="project.projectDrawInfo.drawNumber"
          @entity-selected="entitySelected"
        ></EntityInformation>
        <EntityInformation
          v-model="project.projectInfo.sendBuilderCompletionEmail"
          label="Primary Builder"
          :project-id="project.projectInfo.projectId"
          :entity="project.projectInfo.builder"
          @entity-selected="entitySelected"
          :type="ProjectRole.PRIMARY_BUILDER"
          :draw-number="project.projectDrawInfo.drawNumber"
        ></EntityInformation>
        <EntityInformation
          v-model="project.projectInfo.sendInspectorCompletionEmail"
          label="Primary Inspector"
          :project-id="project.projectInfo.projectId"
          :entity="project.projectInfo.inspector"
          @entity-selected="entitySelected"
          :type="ProjectRole.PRIMARY_INSPECTOR"
          :draw-number="project.projectDrawInfo.drawNumber"
        ></EntityInformation>
      </div>
    </template>
  </Card>

  <TSDialog label="Project Entity Details" v-model:visible="entityToDisplay" icon="info-circle" @after-hide="entityToDisplay = undefined">
    <template #content>
      <EntityDetail v-if="entityToDisplay" :entity="entityToDisplay" />
    </template>
  </TSDialog>
</template>

<script setup lang="ts">
import { ProjectRole } from "@/enums/ProjectRole";
import type { Entity } from "@/types/Entity";
import type { Project } from "@/types/Projects";

interface Props {
  project: Project;
}
const props = defineProps<Props>();

const entityToDisplay = ref<Entity>();

const entitySelected = (entity: Entity): void => {
  entityToDisplay.value = entity;
};
</script>
